export default __webpack_public_path__ + "assets/three-dots-component.303a3aba.svg";